import Table from "../../table/Table"
import { useNavigate } from "react-router-dom"
import { useState,useEffect, useCallback } from "react"
import { usePagination } from "../../../hooks/usePagination"
import ApiService from "../../../services/apiService"
import { toast } from "react-toastify"
import { Button, Card, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap"
import RightIcon from "../../svg/RightIcon"
import LeftIcon from "../../svg/LeftButton"
import LoadingComponent from "../../lodingComponent"

import CommonCardHeader from "../../../coreComponents/CommonCardHeader"
import Breadcrumbs from "../../../coreComponents/breadcrumbs"
import { useAppSelector } from "../../../reduxToolkit/hooks"
import { format } from "date-fns"
import FilterIcon from "../../svg/FilterIcon"
import { Filter } from "react-feather"
const WaterCharges = () =>{
 
    const role = useAppSelector((state) => state.role.role);
    const [waterChargesData,setWaterChargesData] = useState()
    const [isDeleteModalOpen,setIsDeleteModalOpen] = useState<boolean>(false)
    const[selectedWaterChargeId,setSelectedWaterChargeId] = useState<any>()

    const navigate = useNavigate()

    const {
        data,
        pageNumber,
        setPageNumber,
        pageSize,
        totalCount,
        setRefresh,
        setSearchQuery,
        searchQuery,
        filterOn,
        setSortBy,
        loading
    } = usePagination({
        endpoint: `/watercharges`,
        filterOn:'unitPrice',
        enabled:true
    })
    const totalPages = Math.ceil(totalCount / pageSize);

    const handleNext = useCallback(() => {
        setPageNumber((prev) => Math.min(totalPages, prev + 1))
    }, [setPageNumber, totalPages])



    const handlePrev = useCallback(() => {
        setPageNumber((prev) => Math.max(1, prev - 1))
    }, [setPageNumber, totalPages])


   

    const handleUpdate = (id: string) => {
        navigate(`/update-water-charges/${id}`);
    }

    const handleDelete = (id: string) => {
        setSelectedWaterChargeId(id);
        setIsDeleteModalOpen(true);
    }

    const handleDeleteWaterCharge = async (id: string) => {
        try {
           
            const response = await ApiService.axiosApi(`/watercharges/${id}`, {
                method: 'DELETE',
            });

            if (response.success) {
                
                toast.success(response.data.message);
                setIsDeleteModalOpen(false);
                setRefresh(prev => !prev);
            }
            else {
                toast.error(response.data.message);
            }
        } catch (error: any) {
            toast.error(error.message);
        }
    }
    let updatedData ; 
     if(data){
         updatedData = data.map((time)=>{
            return{
               ...time,
               effectiveFrom : format(new Date(time.effectiveFrom),'dd-MM-yyyy HH:mm:ss')
            }
      })     
     }
    
     
    return(
        <>
         <Breadcrumbs mainTitle={'User Charges'} parent={'Configuration'} />
            
            <Card>
                <CommonCardHeader title="User Charges" headClass={"pb-3"} />
                <div className="d-flex justify-content-between">
                <div style={{marginLeft:'10px'}} className='align-items-center flex-row d-flex'>
                    <div>
                    <input 
                   type="text" 
                   className="search-input"
                   placeholder="...search"
                   value={searchQuery}
                   onChange={(e)=>{setSearchQuery(e.target.value)
                       setPageNumber(1)
                   }}
                  
                    />
                    </div>
                       <div>
                       <button className="filter-button mx-2 p-1" style={{height:'30px'}} onClick={()=>setSortBy('unitPrice')}>
                       <Filter />
                   </button>
                       </div>
                    
                </div>
                {role === "Administrator" && (
                    <div className="d-flex justify-content-end">
                        <Button onClick={() => navigate(`/add-water-charges`)} color="primary" className="mb-2 mx-2">Add User Charges</Button>
                    </div>
                )}
                 </div>
                 {loading?<LoadingComponent/>:<Table
                    data={updatedData}
                    columns={[
                        { header: "EffectiveFrom", accessor:"effectiveFrom" },
                        { header: "Unit Price", accessor:"unitPrice" },

                    ]}

                    buttons={[
                        { label: "Edit", onClick: handleUpdate, color: "primary", className: "me-2" },
                        { label: "Delete", onClick: handleDelete, color: "danger" }
                    ]}
                />}
                
                <div className=" d-flex justify-content-end align-content-center" style={{ marginRight: '10px', marginTop: '10px' }}>
                    <p style={{ marginRight: '10px', marginTop: '8px' }}>
                        Page {pageNumber} of {totalPages}
                    </p>
                    <button
                        onClick={handlePrev}
                        disabled={pageNumber === 1}
                        className={`icon-button ${pageNumber === totalPages ? 'disabled' : ''}`}
                    >
                        <LeftIcon className="icon" />
                    </button>
                    <button
                        className={`icon-button ${pageNumber === totalPages ? 'disabled' : ''}`}
                        onClick={handleNext}
                        disabled={pageNumber === totalPages}
                    >
                        <RightIcon className="icon" />
                    </button>
                </div>
            </Card>

            <Modal isOpen={isDeleteModalOpen} toggle={() => setIsDeleteModalOpen(!isDeleteModalOpen)}>
                <ModalHeader>Delete Scheme Village</ModalHeader>
                <ModalBody>Are you sure you want to delete this water charge?</ModalBody>
                <ModalFooter>
                    <Button color="danger" onClick={() => handleDeleteWaterCharge(selectedWaterChargeId)}>Delete</Button>
                    <Button color="secondary" onClick={() => setIsDeleteModalOpen(false)}>Cancel</Button>
                </ModalFooter>
            </Modal>
        </>
    )
}

export default WaterCharges